module.exports = __webpack_public_path__ + "static/media/user-clock.5065c56f.svg";